"use strict";

import warnAboutDeprecatedESMImport from "./warnAboutDeprecatedESMImport.js";
warnAboutDeprecatedESMImport("Route");
import { Route } from "../esm/react-router.js";
export default Route;